<div class="card mb-4" [ngClass]="cardClasses">
    <ng-content select=".card-header"></ng-content><ng-content select=".card-body"></ng-content
    ><ng-content select=".card-footer"></ng-content>
</div>
